export { Marquee } from "./Marquee";
export type { MarqueeProps } from "./types";
